export default "__VITE_ASSET__DAddbxQL__"